module.exports = __webpack_public_path__ + "static/media/icons for website-01.a61ac069.svg";